export type ScanLang = 'en' | 'ko';

const en: Record<string, string> = {
  'lang.en': 'English',
  'lang.ko': '한국어',
  'header.search': 'Search by address, transaction hash, block number...',
  'header.notifications': 'Notifications',
  'header.admin': 'Admin Panel',
  'header.profile': 'Profile',
  'sidebar.connectWallet': 'Connect Wallet',
  'sidebar.connected': 'Connected',
  'sidebar.chainId': 'Chain ID: 88889',
  'sidebar.network': 'Connected to Voltron',
  'sidebar.admin': 'Admin',
  'sidebar.vttnPrice': 'VTTN Price:',
  'sidebar.tps': 'TPS:',
  'sidebar.validators': 'Validators:',
  'sidebar.validatorsActive': 'Active',
  'menu.dashboard': 'Dashboard',
  'menu.blocks': 'Blocks',
  'menu.transactions': 'Transactions',
  'menu.addresses': 'Addresses',
  'menu.tokens': 'Tokens',
  'menu.validators': 'Validators',
  'menu.subnets': 'Subnets',
  'menu.governance': 'Governance',
  'menu.network': 'Network Status',
  'menu.energyBss': 'Energy & BSS',
  'menu.bridge': 'Bridge',
  'admin.menu': 'Admin',
  'admin.dashboard': 'Admin Dashboard',
  'admin.token': 'Voltron Token Management',
  'admin.bonus': 'Bonus Management',
  'admin.walletMgmt': 'Wallet Management',
  'admin.discount': 'Discount Management',
  'admin.wallet': 'Wallet',
  'admin.users': 'User Management',
  'admin.staking': 'Staking Management',
  'admin.nodeSub': 'Node Subscription',
  'admin.tokenTransfer': 'Token Transfer',
  'admin.minting': 'Token Minting Studio',
  'admin.boom': 'BOOM Events',
  'admin.referrals': 'Referrals',
  'admin.referralMgmt': 'Referral Management',
  'admin.serviceMgmt': 'Service Management',
  'admin.settlement': 'Settlement',
  'admin.foundation': 'Foundation Wallet',
  'admin.logs': 'System Logs',
  'admin.security': 'Security',
  'validators.cardView': 'Card view',
  'validators.listView': 'List view',
  'validators.uptime': 'Uptime',
  'validators.totalStaking': 'Total staked:',
  'validators.aiScore': 'AI score',
  'wallet.metamask': 'MetaMask is not installed.',
  'energy.title': 'Energy & BSS Management',
  'energy.subtitle': 'Manage energy stations and battery storage systems in one place',
  'energy.addStation': 'Add energy station',
  'energy.addBss': 'Add BSS node',
  'energy.refresh': 'Refresh',
  'energy.tabEnergy': 'Energy Stations',
  'energy.tabBss': 'BSS Nodes',
  'energy.metricTotalCapacity': 'Total capacity',
  'energy.metricCurrentOutput': 'Current output',
  'energy.metricAvgEfficiency': 'Avg. efficiency',
  'energy.metricTotalRevenue': 'Total revenue',
  'energy.metricCurrentCharge': 'Current charge',
  'energy.metricAvgHealth': 'Avg. health',
  'energy.metricConnectedDevices': 'Connected devices',
  'energy.searchPlaceholder': 'Search by name or location...',
  'energy.filterAllStatus': 'All statuses',
  'energy.filterAllTypes': 'All types',
  'energy.itemsShown': '{n} items shown',
  'energy.colStation': 'Station',
  'energy.colNode': 'Node',
  'energy.colType': 'Type',
  'energy.colStatus': 'Status',
  'energy.colCapacity': 'Capacity / output',
  'energy.colCharge': 'Charge level',
  'energy.colEfficiency': 'Efficiency',
  'energy.colRevenue': 'Revenue',
  'energy.colDevices': 'Devices',
  'energy.colActions': 'Actions',
  'energy.status.online': 'Online',
  'energy.status.offline': 'Offline',
  'energy.status.maintenance': 'Maintenance',
  'energy.status.error': 'Error',
  'energy.status.charging': 'Charging',
  'energy.status.discharging': 'Discharging',
  'energy.status.idle': 'Idle',
  'energy.type.solar': 'Solar',
  'energy.type.wind': 'Wind',
  'energy.type.hydro': 'Hydro',
  'energy.type.nuclear': 'Nuclear',
  'energy.type.thermal': 'Thermal',
  'energy.type.primary': 'Primary',
  'energy.type.secondary': 'Secondary',
  'energy.type.backup': 'Backup',
  'energy.action.aiControl': 'AI control console',
  'energy.action.edit': 'Edit',
  'energy.action.settings': 'Settings',
  'energy.action.delete': 'Delete',
  'energy.modal.addStation': 'Add energy station',
  'energy.modal.addBss': 'Add BSS node',
  'energy.modal.name': 'Name',
  'energy.modal.location': 'Location',
  'energy.modal.type': 'Type',
  'energy.modal.capacityMw': 'Capacity (MW)',
  'energy.modal.capacityKwh': 'Capacity (kWh)',
  'energy.modal.placeholderNameStation': 'Energy station name',
  'energy.modal.placeholderNameBss': 'BSS node name',
  'energy.modal.placeholderLocation': 'Enter location',
  'energy.modal.placeholderCapacity': 'Enter capacity',
  'energy.modal.cancel': 'Cancel',
  'energy.modal.submit': 'Add',
  'ai.title': 'AI control console',
  'ai.nodeId': 'Node ID:',
  'ai.tabControl': 'AI control',
  'ai.tabNode': 'Node info',
  'ai.connection': 'Connection:',
  'ai.online': 'Online',
  'ai.offline': 'Offline',
  'ai.ip': 'IP Address:',
  'ai.batteryStatus': 'Batteries:',
  'ai.stationTemp': 'Station temp:',
  'ai.batteryRack': 'Battery rack',
  'ai.batteryDetail': 'Battery #',
  'ai.autoCharge': 'Auto-charge',
  'ai.on': 'ON',
  'ai.off': 'OFF',
  'ai.startCharge': 'Start charging',
  'ai.stopCharge': 'Stop charging',
  'ai.openDoor': 'Open door',
  'ai.closeDoor': 'Close door',
  'ai.wakeUp': 'Wake up',
  'ai.systemLog': 'System log',
  'ai.txHistory': 'Transactions',
  'ai.noLogs': 'No logs yet',
  'ai.noTx': 'No transactions yet',
  'ai.openAll': 'Open all',
  'ai.closeAll': 'Close all',
  'ai.details': 'Details',
  'ai.legend.presentOpen': 'Battery present, door open',
  'ai.legend.presentClosed': 'Battery present, door closed',
  'ai.legend.safety': 'Safety sensor tripped',
  'ai.legend.emptyOpen': 'Empty, door open',
  'ai.legend.emptyClosed': 'Empty, door closed',
};

const ko: Record<string, string> = {
  'lang.en': 'English',
  'lang.ko': '한국어',
  'header.search': '주소, 트랜잭션 해시, 블록 번호로 검색...',
  'header.notifications': '알림',
  'header.admin': '관리자',
  'header.profile': '프로필',
  'sidebar.connectWallet': '지갑 연결',
  'sidebar.connected': '연결됨',
  'sidebar.chainId': '체인 ID: 88889',
  'sidebar.network': 'Voltron에 연결됨',
  'sidebar.admin': '관리',
  'sidebar.vttnPrice': 'VTTN 가격:',
  'sidebar.tps': 'TPS:',
  'sidebar.validators': '검증자:',
  'sidebar.validatorsActive': '가동',
  'menu.dashboard': '대시보드',
  'menu.blocks': '블록',
  'menu.transactions': '트랜잭션',
  'menu.addresses': '주소',
  'menu.tokens': '토큰',
  'menu.validators': '검증자',
  'menu.subnets': '서브넷',
  'menu.governance': '거버넌스',
  'menu.network': '네트워크 상태',
  'menu.energyBss': '에너지·BSS',
  'menu.bridge': '브릿지',
  'admin.menu': '관리',
  'admin.dashboard': '관리자 대시보드',
  'admin.token': 'Voltron 토큰 관리',
  'admin.bonus': '보너스 관리',
  'admin.walletMgmt': '지갑 관리',
  'admin.discount': '할인 관리',
  'admin.wallet': '지갑',
  'admin.users': '사용자 관리',
  'admin.staking': '스테이킹 관리',
  'admin.nodeSub': '노드 구독',
  'admin.tokenTransfer': '토큰 전송',
  'admin.minting': '토큰 민팅 스튜디오',
  'admin.boom': 'BOOM 이벤트',
  'admin.referrals': '추천',
  'admin.referralMgmt': '레퍼럴 매니지먼트',
  'admin.serviceMgmt': '서비스 관리',
  'admin.settlement': '정산',
  'admin.foundation': '재단 지갑',
  'admin.logs': '시스템 로그',
  'admin.security': '보안',
  'validators.cardView': '카드 뷰',
  'validators.listView': '리스트 뷰',
  'validators.uptime': '가동률',
  'validators.totalStaking': '총 스테이킹:',
  'validators.aiScore': 'AI 점수',
  'wallet.metamask': 'MetaMask가 설치되어 있지 않습니다.',
  'energy.title': 'Energy & BSS 관리',
  'energy.subtitle': '에너지 스테이션과 배터리 저장 시스템을 통합 관리하세요',
  'energy.addStation': '에너지 스테이션 추가',
  'energy.addBss': 'BSS 노드 추가',
  'energy.refresh': '새로고침',
  'energy.tabEnergy': 'Energy Stations',
  'energy.tabBss': 'BSS Nodes',
  'energy.metricTotalCapacity': '총 용량',
  'energy.metricCurrentOutput': '현재 출력',
  'energy.metricAvgEfficiency': '평균 효율',
  'energy.metricTotalRevenue': '총 수익',
  'energy.metricCurrentCharge': '현재 충전량',
  'energy.metricAvgHealth': '평균 상태',
  'energy.metricConnectedDevices': '연결 기기',
  'energy.searchPlaceholder': '이름 또는 위치 검색...',
  'energy.filterAllStatus': '모든 상태',
  'energy.filterAllTypes': '모든 타입',
  'energy.itemsShown': '{n}개 항목 표시',
  'energy.colStation': '스테이션',
  'energy.colNode': '노드',
  'energy.colType': '타입',
  'energy.colStatus': '상태',
  'energy.colCapacity': '용량/출력',
  'energy.colCharge': '충전량',
  'energy.colEfficiency': '효율',
  'energy.colRevenue': '수익',
  'energy.colDevices': '기기',
  'energy.colActions': '액션',
  'energy.status.online': '온라인',
  'energy.status.offline': '오프라인',
  'energy.status.maintenance': '유지보수',
  'energy.status.error': '오류',
  'energy.status.charging': '충전 중',
  'energy.status.discharging': '방전 중',
  'energy.status.idle': '대기',
  'energy.type.solar': '태양광',
  'energy.type.wind': '풍력',
  'energy.type.hydro': '수력',
  'energy.type.nuclear': '원자력',
  'energy.type.thermal': '화력',
  'energy.type.primary': '주요',
  'energy.type.secondary': '보조',
  'energy.type.backup': '백업',
  'energy.action.aiControl': 'AI 관제 시스템',
  'energy.action.edit': '편집',
  'energy.action.settings': '설정',
  'energy.action.delete': '삭제',
  'energy.modal.addStation': '에너지 스테이션 추가',
  'energy.modal.addBss': 'BSS 노드 추가',
  'energy.modal.name': '이름',
  'energy.modal.location': '위치',
  'energy.modal.type': '타입',
  'energy.modal.capacityMw': '용량 (MW)',
  'energy.modal.capacityKwh': '용량 (kWh)',
  'energy.modal.placeholderNameStation': '에너지 스테이션 이름',
  'energy.modal.placeholderNameBss': 'BSS 노드 이름',
  'energy.modal.placeholderLocation': '위치 입력',
  'energy.modal.placeholderCapacity': '용량 입력',
  'energy.modal.cancel': '취소',
  'energy.modal.submit': '추가',
  'ai.title': 'AI 관제 시스템',
  'ai.nodeId': '노드 ID:',
  'ai.tabControl': 'AI 관제',
  'ai.tabNode': '노드 정보',
  'ai.connection': '연결상태:',
  'ai.online': 'Online',
  'ai.offline': 'Offline',
  'ai.ip': 'IP Address:',
  'ai.batteryStatus': '배터리현황:',
  'ai.stationTemp': '스테이션온도:',
  'ai.batteryRack': '배터리 랙',
  'ai.batteryDetail': '배터리 #',
  'ai.autoCharge': '자동충전',
  'ai.on': 'ON',
  'ai.off': 'OFF',
  'ai.startCharge': '충전시작',
  'ai.stopCharge': '충전중지',
  'ai.openDoor': '도어열기',
  'ai.closeDoor': '도어닫기',
  'ai.wakeUp': 'Wake Up',
  'ai.systemLog': '시스템 로그',
  'ai.txHistory': '거래 내역',
  'ai.noLogs': '로그가 없습니다',
  'ai.noTx': '거래 내역이 없습니다',
  'ai.openAll': '전체열기',
  'ai.closeAll': '전체닫기',
  'ai.details': '상세정보',
  'ai.legend.presentOpen': '배터리 있음, 도어 열림',
  'ai.legend.presentClosed': '배터리 있음, 도어 닫힘',
  'ai.legend.safety': '안전 센서 작동',
  'ai.legend.emptyOpen': '배터리 없음, 도어 열림',
  'ai.legend.emptyClosed': '배터리 없음, 도어 닫힘',
};

export const translations: Record<ScanLang, Record<string, string>> = { en, ko };

/** Replace `{n}` placeholders */
export function formatScanString(template: string, vars: Record<string, string | number>): string {
  return Object.entries(vars).reduce(
    (s, [k, v]) => s.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v)),
    template
  );
}
